import Vue from "vue";

/**
 * Class Payment Service
 */
export default class ProductService extends Vue {
  private customActions = {
    indexStatus: { method: 'GET', url: 'lead/product/status/{statusName}' },
    attributeIndex: { method: 'GET', url: 'lead/product_attributes/{platformId}' }
  };
  private resource: any = this.$resource(
    "lead/product/{platformId}{/id}",
    {},
    this.customActions
  );

  // GET all
  public index() {
    let platformId = this.$auth.user().id_platform;
    return this.resource.get({ platformId }).then(
      (response: any) => {
        return response.json();
      },
      (response: any) => {
        return response.json();
      }
    );
  }

  // GET all with statusName
  public indexStatus(statusName: string) {
    return this.resource.indexStatus({ statusName }).then(
      (response: any) => {
        return response.json();
      },
      (response: any) => {
        return response.json();
      }
    );
  }

  // GET one
  public show(id: number) {
    let platformId = this.$auth.user().id_platform;
    return this.resource.get({ platformId, id }).then(
      (response: any) => {
        return response.json();
      },
      (response: any) => {
        return response.json();
      }
    );
  }

  // POST
  public store(data: any) {
    let platformId = this.$auth.user().id_platform;
    return this.resource.save({ platformId }, data).then(
      (response: any) => {
        return response.json();
      },
      (response: any) => {
        return response.json();
      }
    );
  }

  // PUT
  public update(id: number, data: any) {
    let platformId = this.$auth.user().id_platform;
    return this.resource.update({ platformId, id }, data).then(
      (response: any) => {
        return response.json();
      },
      (response: any) => {
        return response.json();
      }
    );
  }

  // DELETE
  public delete(id: number) {
    let platformId = this.$auth.user().id_platform;
    return this.resource.delete({ platformId, id }).then(
      (response: any) => {
        return response.json();
      },
      (response: any) => {
        return response.json();
      }
    );
  }

  // List platform attributes
  public attributeIndex() {
    let platformId = this.$auth.user().id_platform;
    return this.resource.attributeIndex({ platformId });
  }
}
